/* src/app/components/shared/styles/nav-header.css */
.fusion-navbar {
  background-color: var(--navy-600);
  min-height: 74px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1010;
  padding: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.ps-nav {
  padding-left: 12px !important;
  padding-right: 16px !important;
}
.brand-logo-wrap {
  display: flex;
  align-items: center;
  padding: 0 4px;
  margin-right: 14px;
}
.brand-logo-wrap img {
  height: 46px;
}
.brand-title {
  color: var(--fg-on-navy);
  font-size: 1.3em;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.08em;
}
.nav-item-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  font-size: 1.05em;
  padding: 8px 14px !important;
  border-radius: var(--radius-xs);
  white-space: nowrap;
  display: flex;
  align-items: center;
  text-decoration: none;
}
@media (max-width: 1400px) {
  .nav-item-btn {
    font-size: 0.92em;
    padding: 6px 9px !important;
  }
  .header-icon-btn {
    padding: 5px 6px !important;
  }
  .lang-flag {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
  .lang-flag-fr {
    margin-right: 6px;
  }
}
.nav-item-btn:hover {
  color: var(--fg-on-navy) !important;
  background-color: rgba(255, 255, 255, 0.12);
}
.nav-item-active {
  color: var(--fg-on-navy) !important;
  background-color: rgba(255, 255, 255, 0.15);
}
.header-icon-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  padding: 8px 10px !important;
  position: relative;
  font-size: 1.15em;
}
.header-icon-btn:hover {
  color: var(--fg-on-navy) !important;
}
.lang-flag {
  width: 26px;
  height: 26px;
  cursor: pointer;
  margin-right: 6px;
  opacity: 0.9;
}
.lang-flag-fr {
  margin-right: 10px;
}
.unselected_lang {
  -webkit-filter: grayscale(75%);
  filter: grayscale(75%);
  opacity: 0.5;
}
.notification_num {
  font-size: 11px;
  position: absolute;
  top: 2px;
  right: 2px;
  color: white;
  background-color: crimson;
  padding: 0 4px;
  border-radius: 3px;
  line-height: 1.4;
}
.mobile-toggler-btn:hover {
  background: rgba(255, 255, 255, 0.14) !important;
}
.mobile-toggler-btn:focus {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.18) !important;
}
.mobile-nav-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--fg-on-navy) !important;
}
.mobile-nav-active {
  background: rgba(255, 255, 255, 0.11) !important;
  color: var(--fg-on-navy) !important;
  border-left: 3px solid rgba(100, 170, 255, 0.75);
  padding-left: 17px !important;
}
.mobile-nav-icon {
  margin-right: 13px;
  flex-shrink: 0;
  opacity: 0.88;
}
.mobile-chevron {
  margin-left: auto;
  opacity: 0.5;
  flex-shrink: 0;
}
.mobile-nav-sublink {
  display: block;
  width: 100%;
  padding: 11px 20px 11px 48px;
  color: rgba(255, 255, 255, 0.72) !important;
  font-size: 0.93em;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  cursor: pointer;
  text-align: left;
  transition: background 0.12s, color 0.12s;
}
.mobile-nav-sublink:hover {
  background: rgba(255, 255, 255, 0.07);
  color: var(--fg-on-navy) !important;
}
.mobile-footer-btn:hover {
  background: rgba(255, 255, 255, 0.13);
  color: var(--fg-on-navy);
}
.mobile-logout-btn:hover {
  background: rgba(220, 50, 50, 0.15) !important;
  color: var(--danger) !important;
}
.mobile-notif-badge {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 10px;
  background: crimson;
  color: white;
  padding: 0 3px;
  border-radius: 3px;
  line-height: 1.5;
  pointer-events: none;
}
a:hover {
  cursor: pointer;
}
.user-avatar-btn {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
}
/*# sourceMappingURL=nav-header.css.map */
